<script lang="ts">
	import { Tween } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import type { Snippet } from 'svelte';

	interface Props {
		value: number;
		duration?: number;
		easing?: (t: number) => number;
		children: Snippet<[number]>;
	}

	let { value, duration = 300, easing = cubicOut, children }: Props = $props();

	const tweenedValue = new Tween(0, {
		duration,
		easing
	});

	$effect(() => {
		tweenedValue.set(value);
	});
</script>

{@render children(tweenedValue.current)}
